import PlotService from '@/services/plot.service.js'

function asPlotList (value) {
    if (Array.isArray(value)) {
        return value;
    }
    if (!value || typeof value !== 'object') {
        return [];
    }
    if (Array.isArray(value.data)) {
        return value.data;
    }
    if (Array.isArray(value.plots)) {
        return value.plots;
    }
    const keys = Object.keys(value);
    if (keys.length && keys.every((key) => /^\d+$/.test(key))) {
        return keys.sort((a, b) => Number(a) - Number(b)).map((key) => value[key]);
    }
    return [];
}

export default {
    namespaced: true,
    state: () => ({
        plots: [],
        search: ''
    }),
    mutations: {
        setPlots (state, value) {
            state.plots = asPlotList(value);
        },
        setSearchPlots (state, value) {
            state.search = value;
        }
    },
    getters: {
        search (state) {
            return state.search;
        },
        plots (state) {
            const plots = asPlotList(state.plots);
            if (state.search) {
                return plots.filter((plot) => {
                    return plot.name.toLowerCase().includes(state.search) || plot.id.toString().includes(state.search)
                });
            }
            return plots;
        }
    },
    actions: {
        setSearchPlots ({commit}, search = '') {
            commit("setSearchPlots", search);
        },
        setPlots ({commit}, plots) {
            commit("setPlots", plots);
        },
        getPlots ({commit}) {
            return new Promise((resolve, reject) => {
                PlotService.getPlots()
                .then(resp => {
                    const plots = asPlotList(resp);
                    commit("setPlots", plots);
                    resolve(plots);
                })
                .catch(err => {
                    reject(err);
                })
            })
        },
        findPlot ({ state }, plot_id) {
            return new Promise((resolve) => {
                resolve(asPlotList(state.plots).find(plot => plot.id === plot_id));
            })
        },
        findPlotByTreeId ({state}, tree_id) {
            return new Promise ((resolve) => {
                resolve(asPlotList(state.plots).find(plot => plot.lower_range <= tree_id && plot.upper_range >= tree_id));
            })
        }
    },
};
